import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationManagerService } from 'src/app/shared/services/navigation-manager.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-site-manager',
  templateUrl: './site-manager.component.html',
  styleUrls: ['./site-manager.component.scss'],
})
export class SiteManagerComponent implements OnInit, OnDestroy {
  subscriptionNavigation: Subscription | undefined;
  subscriptionHeaderFooter: Subscription | undefined;
  navigationSharedData: any;
  sharedData: any;
  enableBackOperation!: boolean | true;
  defaultNavigation: string = CONSTANTS.SITE;
  result: boolean | undefined;
  removeAP: boolean | undefined;
  noErrorToasterShow = false;

  constructor(
    public navigationManagerService: NavigationManagerService,
    public sharedDataService: SharedDataService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.enableBackOperation = data.enableBackOperation ?? true;
    this.defaultNavigation = data.defaultNavigation ?? CONSTANTS.SITE;
    this.removeAP = data?.removeAP;
    this.noErrorToasterShow = data?.noErrorToasterShow ?? false;
  }
  /**
   * @description: runs on when component is initialized.
   * @input {none}
   * @output {void}
   */

  ngOnInit(): void {
    this.subscriptionNavigation =
      this.navigationManagerService.currentData.subscribe(
        (stepSharedData) => (this.navigationSharedData = stepSharedData)
      );
    this.subscriptionHeaderFooter =
      this.sharedDataService.currentData.subscribe(
        (sharedData) => (this.sharedData = sharedData)
      );
    this.navigationManagerService.setStepSiteManager(this.defaultNavigation);
  }

  /**
   * @description: runs just before component unmount. Unsubscribes the sharedDataService service
   * @input {none}
   * @output {void}
   */

  ngOnDestroy(): void {
    this.subscriptionNavigation?.unsubscribe();
    this.subscriptionHeaderFooter?.unsubscribe();
  }

  /**
   * @description: navigateToEditSite function set the Site navigation to SITE
   * @input { none }
   * @output { void }
   */

  navigateToEditSite = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.SITE);
  };

  /**
   * @description: navigateToAddBuilding function set the Site navigation to BUILDING
   * @input { none }
   * @output { void }
   */

  navigateToAddBuilding = (result: boolean): void => {
    this.result = result;
    this.navigationManagerService.setStepSiteManager(CONSTANTS.BUILDING);
  };

  /**
   * @description: navigateToAddFloor function set the Site navigation to FLOOR
   * @input { none }
   * @output { void }
   */

  navigateToAddFloor = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.FLOOR);
  };

  /**
   * @description: navigateToRemoveUnit function set the Site navigation to REMOVE_UNIT
   * @input { none }
   * @output { void }
   */

  navigateToRemoveUnit = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.REMOVE_UNIT);
  };

  /**
   * @description: navigateToEditUnit function set the Site navigation to EDIT_UNIT
   * @input { none }
   * @output { void }
   */

  navigateToEditUnit = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.EDIT_UNIT);
  };

  /**
   * @description: navigateToFiletrUnit function set the Site navigation to FILTER_UNIT
   */

  navigateToFiletrUnit = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.FILTER_UNIT);
  };

  /**
   * @description: navigateToMasterCredential function set the Site navigation to MASTER_CREDENTIAL
   * @input { none }
   * @output { void }
   */
  navigateToMasterCredential = (): void => {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.MASTER_CREDENTIAL
    );
  };

  /* @description: navigateConfirmDialog function set the Site navigation to navigateConfirmDialog
   * @input { none }
   * @output { void }
   */
  navigateConfirmDialog = (): void => {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.CONFIRM_DIALOG,
      this.navigationSharedData?.step
    );
  };

  /**
   * @description: closeConfirmDialog function set the Site navigation to closeConfirmDialog
   * @input { none }
   * @output { void }
   */

  closeConfirmDialog = (): void => {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.CLOSE_CONFIRM_DIALOG,
      this.navigationSharedData?.step
    );
  };

  /**
   * @description: navigateToRemoveUnit function set the Site navigation to resetNavigation
   * @input { none }
   * @output { void }
   */

  resetNavigation = (): void => {
    this.navigationManagerService.setStepSiteManager(CONSTANTS.RESET);
  };

  /**
   * @description: navigateToEditMasterCredential function set the Site navigation to EDIT_MASTER_CREDENTIAL
   * @input { none }
   * @output { void }
   */

  navigateToEditMasterCredential = (): void => {
    this.navigationManagerService.setStepSiteManager(
      CONSTANTS.EDIT_MASTER_CREDENTIAL
    );
  };
}
